import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { PageMode } from '@confluence/page-utils/entry-points/enums.ts';
import { useGetPageMode } from '@confluence/page-utils/entry-points/useGetPageMode.ts';
import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';

import { pageJustPublishedSignal } from '../utils/pageJustPublishedSignal.ts';

import { isUnderStructuredReviewCandidate } from './isUnderStructuredReviewCandidate.ts';

/**
 * OnPublish event-trigger detection for the Content Reviewer nudge.
 *
 * Restricted to the view page: the signal is armed in the editor publish flow, so it must only
 * surface once the user lands on the published page's view surface — never back in edit/live mode.
 */
export const useContentReviewerNudgeOnPublishSignal = (contentId: string): boolean => {
	const { isRovoLLMEnabled, isAIEarlyAccessEnabled, isAdminHubAIEnabled } = useSessionData();
	const pageMode = useGetPageMode();
	const hasDismissedNudge = confluenceLocalStorageInstance.getItemAsBoolean(
		keys.AUTOMATION_DISCOVER_CONTENT_REVIEWER,
	);

	const hasPageJustPublishedSignalForThisContent =
		Boolean(contentId) && pageJustPublishedSignal.contentId === contentId;

	return Boolean(
		isRovoLLMEnabled &&
		isAIEarlyAccessEnabled &&
		isAdminHubAIEnabled &&
		pageMode === PageMode.VIEW &&
		!hasDismissedNudge &&
		hasPageJustPublishedSignalForThisContent &&
		isUnderStructuredReviewCandidate(pageJustPublishedSignal.adf),
	);
};
